import React from "react";
import Stepper from "./Stepper/Stepper";
import { useSelector } from "react-redux";
import PersonalInformation from "../pages/protector/divorce/SubForms/PersonalInformation/PersonalInformation";
import AssetDocumentation from "../pages/protector/divorce/SubForms/AssetDocumentation/AssetDocumentation";
import IncomeInformation from "../pages/protector/divorce/SubForms/IncomeInformation/IncomeInformation";
import DebtAndLiabilities from "../pages/protector/divorce/SubForms/DebtAndLiabilities/DebtAndLiabilities";
import MonthlyBudget from "../pages/protector/divorce/SubForms/MonthlyBudget/MonthlyBudget";
import InsuranceCoverage from "../pages/protector/divorce/SubForms/InsuranceCoverage/InsuranceCoverage";
import LegalDocumentation from "../pages/protector/divorce/SubForms/LegalDocumentation/LegalDocumentation";
import ChildCustodyConsiderations from "../pages/protector/divorce/SubForms/ChildCustodyConsiderations/ChildCustodyConsiderations";
import BusinessInterests from "../pages/protector/divorce/SubForms/BusinessInterests/BusinessInterests";
import SupportCalculations from "../pages/protector/divorce/SubForms/SupportCalculations/SupportCalculations";
import ProfessionalTeam from "../pages/protector/divorce/SubForms/ProfessionalTeam/ProfessionalTeam";
export default function DivorceStepper() {
  const unsavedChanges = useSelector(
    (state) => state.rootReducer.loginUser.unsavedChanges
  );
  const mysteps = [
    {
      step: "1",
      name: "Personal Information",
    },
    {
      step: "2",
      name: "Asset Documentation",
    },
    {
      step: "3",
      name: "Income Information",
    },
    {
      step: "4",
      name: "Debt and Liabilities",
    },
    {
      step: "5",
      name: "Monthly Budget",
    },
    {
      step: "6",
      name: "Insurance Coverage",
    },
    {
      step: "7",
      name: "Legal Documentation",
    },
    {
      step: "8",
      name: "Child Custody Considerations",
    },
    {
      step: "9",
      name: "Business Interests",
    },
    {
      step: "10",
      name: "Support Calculations",
    },
    {
      step: "11",
      name: "Professional Team",
    },
  ];

  const contentComponents = [
    PersonalInformation,
    AssetDocumentation,
    IncomeInformation,
    DebtAndLiabilities,
    MonthlyBudget,
    InsuranceCoverage,
    LegalDocumentation,
    ChildCustodyConsiderations,
    BusinessInterests,
    SupportCalculations,
    ProfessionalTeam,
  ];

  return (
    <>
      <Stepper steps={mysteps} contentComponents={contentComponents} unsavedChanges={unsavedChanges} />
    </>
  );
}
